import React from 'react';
import Logo from '@/assets/images/logo.svg';
import { $t } from "@/modules/i18n";
import Subscribe from '@/modules/Subscribe';

class Footer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { message } = this.props;
    return (
      <footer className="footer-container">
        <div className="row-container">
          <div className="left-container">
            <div className="logo-container">
              {
                !message.hideLogo
                ? <a className="logo-group">
                  <img className="logo" src={Logo} alt="Shopee Logo" />
                </a>
                : null
              }
            </div>
            <div className="follow-us-container">
              <p className="text">{$t(message.follow)}</p>
              <div className="soical">
                {
                  (message.social || []).map(item => (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={item.name}
                    >
                      <img
                        src={item.icon}
                        className="icon"
                        alt={item.name}
                      ></img>
                    </a>
                  ))
                }
              </div>
            </div>

            <div className="subscribe">
                <div className="subscribe-desc">{$t(message.letterMessage)}</div>
                <Subscribe popUpBodyStyle={{ height: 'calc(100% - 48px)' }}/>
            </div>

            <div className="subscribe mobile">
                <div className="subscribe-desc">{$t(message.letterMessage)}</div>
                <Subscribe />
            </div>
          </div>
          <div className="right-container">
            <div className="website">
              <span className="label">{$t(message.career)}</span>
              {
                message.websiteLinks.map((item, index) => {
                  return (
                    <a key={index} target="_blank" href={item.href} className="link">{$t(item.text)}</a>
                  )
                })
              }
            </div>
            <div className="other">
              <span className="label">{$t(message.more)}</span>
              {
                message.otherLinks.map((item, index) => {
                  return (
                    <a key={index} target="_blank" href={item.href} className="link">{$t(item.text)}</a>
                  )
                })
              }
            </div>
          </div>
          
          
        </div>

        <div className="copyright">
          <p>
            {$t(message.copyright)}
            {
              message.tc ? <span className="tc">| <a href={message.tc} target="_blank" rel="noopener noreferrer">{$t(message.privacyPolicyText)}</a></span> : null
            }
            {
              message.privacyPolicy ? <span className="pp">| <a href={message.privacyPolicy} target="_blank" rel="noopener noreferrer">{$t(message.tcText)}</a></span> : null
            }
          </p>
        </div>
      </footer>
    )
  }
}

export default Footer;